__turbopack_context__.v({
  "publicLegalPage": "X3NP6q_publicLegalPage",
  "publicLegalPage__backControl": "X3NP6q_publicLegalPage__backControl",
  "publicLegalPage__header": "X3NP6q_publicLegalPage__header",
  "publicLegalPage__panel": "X3NP6q_publicLegalPage__panel",
  "publicLegalPage__scrollControls": "X3NP6q_publicLegalPage__scrollControls",
  "publicLegalPage__skeleton": "X3NP6q_publicLegalPage__skeleton",
  "publicLegalPage__state": "X3NP6q_publicLegalPage__state",
  "publicLegalPage__subtitle": "X3NP6q_publicLegalPage__subtitle",
  "publicLegalPage__title": "X3NP6q_publicLegalPage__title",
});
